"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sbFetch = exports.customAuthenticationHeader = void 0;

var _defaults = _interopRequireDefault(require("lodash/defaults"));

var _createSbApiError = require("../errors/create-sb-api-error");

var _createSbHttpError = require("../errors/create-sb-http-error");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @desc
 * The custom authentication header is used to turn off the browser popup when a 401 message is received
 */
var customAuthenticationHeader = {
  'X-Authentication-UI': 'UI-CUSTOM-AUTHENTICATION'
};
exports.customAuthenticationHeader = customAuthenticationHeader;
var defaultSettings = {
  method: 'GET',
  credentials: 'same-origin',
  // this option will send cookies (with auth) in every request
  ignoreErrors: false,
  ignoreOnUnauthorized: false,
  headers: customAuthenticationHeader
};
/**
 * @desc
 * Creates and triggers custom onUnauthorized event, catchable anywhere by adding its listener.
 */

var handleOnUnauthorized = function handleOnUnauthorized() {
  var event = new CustomEvent('onUnauthorized');
  window.dispatchEvent(event);
};
/**
 * @desc
 * Function for making HTTP calls. It automatically detects business error responses
 * from the REST API and throws an error, catchable via .catch().
 *
 * Limitations:
 * This only supports 'application/json' and 'text/plain' headers, any other types
 * will be returned a raw response.  For other types, use the rawResponse argument.
 *
 * Documentation to original fetch:
 * https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 *
 * or more human friendly version from David Walsh:
 * https://davidwalsh.name/fetch
 *
 * Custom arguments:
 *  - {boolean}   rawResponse           - If true, raw result from response will be returned.
 *  - {boolean}   ignoreErrors          - If true, native fetch's success detection will be ignored.
 *  - {boolean}   ignoreOnUnauthorized  - If true, response with 401 http code or API 'unauthorized' response will be ignored.
 *
 * @param   {string}    url       - Endpoint URL.
 * @param   {object}    args      - Original fetch arguments.
 * @returns {Promise}   *         - Original fetch promise.
 *
 */


var sbFetch = function sbFetch(url) {
  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var settings = (0, _defaults.default)(args, defaultSettings);
  return fetch(url, settings) // First, check if we got correct HTTP error status.
  .then(function (response) {
    var status = response.status;
    var ignoreErrors = settings.ignoreErrors,
        ignoreOnUnauthorized = settings.ignoreOnUnauthorized;

    if (status === 401 && !ignoreOnUnauthorized) {
      handleOnUnauthorized();

      if (!ignoreErrors) {
        return Promise.reject((0, _createSbHttpError.createSbHttpError)(response));
      }
    }

    if (!response.ok && !ignoreErrors) {
      // Fields from original Response object will be accessible as error.detail
      return Promise.reject((0, _createSbHttpError.createSbHttpError)(response));
    }

    return response;
  }) // Try to detect response's content type and use suitable parser.
  .then(function (response) {
    if (args.rawResponse) {
      return response;
    }

    var responseType = response.headers.get('Content-Type');

    if (responseType) {
      if (responseType.indexOf('application/json') !== -1) {
        return response.json();
      }

      if (responseType.indexOf('text/plain') !== -1) {
        return response.text();
      }
    }

    return response;
  }) // Check if response object has 'error' key and possibly throw exception.
  .then(function (response) {
    if (response && response.error) {
      var reason = response.error.reason;

      if (reason && reason === 'unauthorized' && settings.ignoreOnUnauthorized !== true) {
        handleOnUnauthorized();
      }

      return Promise.reject((0, _createSbApiError.createSbApiError)(response.error));
    }

    return response;
  });
};

exports.sbFetch = sbFetch;
//# sourceMappingURL=sb-fetch.js.map